// user Initial Values Formik

export const widgetEditorCode = {
  developerEmails: []
};
